import { render, staticRenderFns } from "./AnalyseAlternativesCompare.vue?vue&type=template&id=43f4969a&scoped=true"
import script from "./AnalyseAlternativesCompare.vue?vue&type=script&lang=js"
export * from "./AnalyseAlternativesCompare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f4969a",
  null
  
)

export default component.exports